import { connectColors } from '@/theme/colors';
import { Button } from '@lego/connect-components-react';
import type { PropsWithChildren } from 'react';

type LeftSidePanelProps = {
  title: string;
  showBackArrow?: boolean;
  onBack?: () => void;
};

const LeftSidePanel = ({
  title,
  showBackArrow,
  onBack,
  children,
}: PropsWithChildren<LeftSidePanelProps>) => {
  return (
    <div
      className="elevation-sm"
      style={{
        padding: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        alignSelf: 'flex-start',
        boxSizing: 'border-box',
        minHeight: '100%',
        background: connectColors.core.white,
        width: '20vw',
        minWidth: '400px',
        maxWidth: '500px',
        flexShrink: 0,
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '16px',
        }}
      >
        {showBackArrow && (
          <Button
            aria-label="back-arrow"
            iconName="arrow-left"
            appearance="ghost"
            onClick={onBack}
            isIconOnly
            size="small"
          />
        )}
        <span className="heading-md" color={connectColors.core.offBlack}>
          {title}
        </span>
      </div>
      {children}
    </div>
  );
};
export default LeftSidePanel;
